import React from 'react';
import { connect } from "react-redux";
import { toast } from "react-toastify";
import moment from 'moment';

import DashboardServices from "../../services/dashboard";
import './styles.css';

const MESES = ['JAN.', 'FEV.', 'MAR.', 'ABR.', 'MAI.', 'JUN.', 'JUL.', 'AGO.', 'SET.', 'OUT.', 'NOV.', 'DEZ.'];
const DESIGNERS = ['NICOLAS', 'KAMILA', 'ADILSON-AT', 'GEOVANE', 'LORRANA'];

class DashboardProcedimentos extends React.Component {

  state = {
    loading: true,
    ano: new Date().getFullYear(),
    designer: '',
    procedimentos: [],
    // cronograma semanal
    cronogramaLoading: false,
    cronogramaData: [],
    cronogramaSemanaInicio: this.getSegundaFeira(new Date()),
    // modal detalhe
    detalheAberto: false,
    detalheLoading: false,
    detalheTitulo: '',
    detalheContratos: [],
    // modal timeline
    timelineAberto: false,
    timelineLoading: false,
    timelineContrato: null,
    timelineProcedimentos: [],
    timelineRefeito: null,
    // modal comentario
    comentarioAberto: false,
    comentarioLoading: false,
    comentarioProc: null,
    comentarios: [],
    novoComentario: '',
    salvandoComentario: false
  }

  getSegundaFeira (date) {
    const d = new Date(date);
    const dia = d.getDay();
    const diff = dia === 0 ? -6 : 1 - dia;
    d.setDate(d.getDate() + diff);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  async componentDidMount () {
    this.carregarDados();
    this.carregarCronograma();
  }

  async carregarDados () {
    const dashboard = new DashboardServices();
    this.setState({ loading: true });

    try {
      const resp = await dashboard.getProcedimentosMensal(this.state.ano, this.state.designer);
      this.setState({
        procedimentos: resp.procedimentos || [],
        loading: false
      });
    } catch (erro) {
      console.error(erro);
      toast.error("Erro ao carregar dados");
      this.setState({ loading: false });
    }
  }

  async carregarCronograma () {
    const dashboard = new DashboardServices();
    this.setState({ cronogramaLoading: true });

    try {
      const dataInicio = moment(this.state.cronogramaSemanaInicio).format('YYYY-MM-DD');
      const resp = await dashboard.getCronogramaSemanal(dataInicio, this.state.designer);
      this.setState({
        cronogramaData: resp.procedimentos || [],
        cronogramaLoading: false
      });
    } catch (erro) {
      console.error(erro);
      toast.error("Erro ao carregar cronograma");
      this.setState({ cronogramaLoading: false });
    }
  }

  navegarSemana (direcao) {
    const { cronogramaSemanaInicio } = this.state;
    const nova = new Date(cronogramaSemanaInicio);
    nova.setDate(nova.getDate() + (direcao * 7));
    this.setState({ cronogramaSemanaInicio: nova }, () => this.carregarCronograma());
  }

  async abrirDetalhe (tipo, mes, status) {
    const { ano, designer } = this.state;
    const dashboard = new DashboardServices();
    const nomeMes = MESES[mes - 1];
    const statusLabel = status === 'concluido' ? 'Concluídos' : 'Agendados';

    this.setState({
      detalheAberto: true,
      detalheLoading: true,
      detalheTitulo: `${tipo} - ${nomeMes} ${ano} - ${statusLabel}`,
      detalheContratos: []
    });

    try {
      const resp = await dashboard.getDetalheProcedimentoMensal(ano, mes, tipo, status, designer);
      this.setState({
        detalheContratos: resp.contratos || [],
        detalheLoading: false
      });
    } catch (erro) {
      console.error(erro);
      toast.error("Erro ao carregar detalhes");
      this.setState({ detalheLoading: false });
    }
  }

  fecharDetalhe () {
    this.setState({ detalheAberto: false, detalheContratos: [], detalheTitulo: '' });
  }

  async abrirTimeline (codigo) {
    const dashboard = new DashboardServices();
    this.setState({
      timelineAberto: true,
      timelineLoading: true,
      timelineContrato: null,
      timelineProcedimentos: []
    });

    try {
      const resp = await dashboard.getContratoTimeline(codigo);
      this.setState({
        timelineContrato: resp.contrato,
        timelineProcedimentos: resp.procedimentos || [],
        timelineRefeito: resp.refeito || null,
        timelineLoading: false
      });
    } catch (erro) {
      console.error(erro);
      toast.error("Erro ao carregar cronograma");
      this.setState({ timelineLoading: false });
    }
  }

  fecharTimeline () {
    this.setState({ timelineAberto: false, timelineContrato: null, timelineProcedimentos: [], timelineRefeito: null });
  }

  async abrirComentario (proc) {
    const dashboard = new DashboardServices();
    const contrato = this.state.timelineContrato ? this.state.timelineContrato.contrato : null;
    if (!proc.Registro || !contrato) return;

    this.setState({
      comentarioAberto: true,
      comentarioLoading: true,
      comentarioProc: proc,
      comentarios: [],
      novoComentario: ''
    });

    try {
      const resp = await dashboard.getComentarios(proc.Registro, contrato);
      this.setState({ comentarios: resp.comentarios || [], comentarioLoading: false });
    } catch (erro) {
      console.error(erro);
      toast.error("Erro ao carregar comentários");
      this.setState({ comentarioLoading: false });
    }
  }

  fecharComentario () {
    this.setState({ comentarioAberto: false, comentarioProc: null, comentarios: [], novoComentario: '' });
  }

  async salvarComentario () {
    const { comentarioProc, novoComentario, timelineContrato } = this.state;
    if (!novoComentario.trim()) return;

    const dashboard = new DashboardServices();
    const usuario = this.props.usuario ? this.props.usuario.nome || this.props.usuario.email || '' : '';

    this.setState({ salvandoComentario: true });
    try {
      await dashboard.salvarComentario(
        comentarioProc.Registro,
        timelineContrato.contrato,
        novoComentario.trim(),
        usuario
      );
      toast.success("Comentário salvo");
      this.setState({ novoComentario: '' });
      const resp = await dashboard.getComentarios(comentarioProc.Registro, timelineContrato.contrato);
      this.setState({ comentarios: resp.comentarios || [], salvandoComentario: false });
    } catch (erro) {
      console.error(erro);
      toast.error("Erro ao salvar comentário");
      this.setState({ salvandoComentario: false });
    }
  }

  getStepClass (proc) {
    const status = (proc.Status || '').toLowerCase();
    if (proc.atrasado) return 'pm-step-atrasado';
    if (status === 'concluido') return 'pm-step-concluido';
    if (status === 'execução' || status === 'execucao') return 'pm-step-execucao';
    return 'pm-step-aguardando';
  }

  calcularTotais (proc) {
    const mesAtual = new Date().getMonth() + 1;
    const anoAtual = new Date().getFullYear();
    const isAnoAtual = this.state.ano === anoAtual;
    const limiteConc = isAnoAtual ? mesAtual : 12;

    let totalConcluido = 0;
    let totalAgendado = 0;
    for (let m = 1; m <= 12; m++) {
      if (m <= limiteConc) totalConcluido += proc.concluidos[m] || 0;
      const ag = proc.agendados[m];
      if (ag) totalAgendado += ag.total || 0;
    }
    return { totalConcluido, totalAgendado };
  }

  renderTabelaProcedimento (proc) {
    const { totalConcluido, totalAgendado } = this.calcularTotais(proc);
    const mesAtual = new Date().getMonth() + 1;
    const anoAtual = new Date().getFullYear();
    const isAnoAtual = this.state.ano === anoAtual;

    return (
      <div key={proc.procedimento} className="proc-mensal-bloco">
        <h3 className="proc-mensal-titulo">{proc.procedimento}</h3>
        <div className="table-responsive">
          <table className="table table-bordered proc-mensal-tabela">
            <thead>
              <tr>
                <th className="proc-mensal-label-col"></th>
                {MESES.map((mes, i) => (
                  <th key={i} className={isAnoAtual && (i + 1) === mesAtual ? 'proc-mensal-mes-atual' : ''}>
                    {mes}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr className="proc-mensal-row-concluido">
                <td className="proc-mensal-label">Concluído:</td>
                {MESES.map((_, i) => {
                  const val = proc.concluidos[i + 1] || 0;
                  return (
                    <td key={i}
                      className={val > 0 ? 'proc-mensal-val-concluido proc-mensal-clicavel' : 'proc-mensal-val-zero'}
                      onClick={val > 0 ? () => this.abrirDetalhe(proc.procedimento, i + 1, 'concluido') : undefined}
                    >
                      {val || ''}
                    </td>
                  );
                })}
              </tr>
              <tr className="proc-mensal-row-agendado">
                <td className="proc-mensal-label">Agendado:</td>
                {MESES.map((_, i) => {
                  const ag = proc.agendados[i + 1];
                  const val = ag ? ag.total : 0;
                  return (
                    <td key={i}
                      className={val > 0 ? 'proc-mensal-val-agendado proc-mensal-clicavel' : 'proc-mensal-val-zero'}
                      onClick={val > 0 ? () => this.abrirDetalhe(proc.procedimento, i + 1, 'agendado') : undefined}
                    >
                      {val || ''}
                    </td>
                  );
                })}
              </tr>
            </tbody>
          </table>
        </div>
        <div className="proc-mensal-totais">
          <div className="proc-mensal-total-item">
            <span className="proc-mensal-total-label">Total concluído:</span>
            <span className="proc-mensal-total-valor concluido">{totalConcluido}</span>
          </div>
          <div className="proc-mensal-total-item">
            <span className="proc-mensal-total-label">Total agendado:</span>
            <span className="proc-mensal-total-valor agendado">{totalAgendado}</span>
          </div>
        </div>
      </div>
    );
  }

  renderDetalhe () {
    const { detalheAberto, detalheLoading, detalheTitulo, detalheContratos } = this.state;
    if (!detalheAberto) return null;

    return (
      <div className="pm-modal-overlay" onClick={() => this.fecharDetalhe()}>
        <div className="pm-modal" onClick={(e) => e.stopPropagation()}>
          <div className="pm-modal-header">
            <h4>{detalheTitulo}
              <span className="pm-modal-badge">{detalheContratos.length} contratos</span>
            </h4>
            <button className="pm-modal-close" onClick={() => this.fecharDetalhe()}>
              <i className="fa fa-times"></i>
            </button>
          </div>
          <div className="pm-modal-body">
            {detalheLoading ? (
              <div className="text-center" style={{ padding: 40 }}>
                <i className="fa fa-refresh fa-spin" style={{ fontSize: 24 }}></i>
                <p style={{ marginTop: 10 }}>Carregando...</p>
              </div>
            ) : detalheContratos.length === 0 ? (
              <p className="text-center text-muted" style={{ padding: 30 }}>Nenhum contrato encontrado.</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered table-hover pm-detalhe-table">
                  <thead>
                    <tr>
                      <th>Contrato</th>
                      <th>Procedimento</th>
                      <th>Designer</th>
                      <th>Status</th>
                      <th>Prazo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detalheContratos.map((c, i) => (
                      <tr key={i}>
                        <td>
                          <span className="pm-contrato-link" onClick={() => this.abrirTimeline(c.codContrato)}>
                            {c.contrato || c.codContrato}
                          </span>
                        </td>
                        <td>{c.procedimento}</td>
                        <td>{c.RegistradoPor || '-'}</td>
                        <td>
                          {(c.status || '').toLowerCase() === 'concluido' ? (
                            <span className="pm-label-status pm-label-concluido">Concluído</span>
                          ) : (
                            <span className="pm-label-status pm-label-agendado">Agendado</span>
                          )}
                        </td>
                        <td>{c.dtfim ? moment(c.dtfim).format('DD/MM/YYYY') : '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderTimeline () {
    const { timelineAberto, timelineLoading, timelineContrato, timelineProcedimentos, timelineRefeito } = this.state;
    if (!timelineAberto) return null;

    return (
      <div className="pm-timeline-overlay" onClick={() => this.fecharTimeline()}>
        <div className="pm-timeline-modal" onClick={(e) => e.stopPropagation()}>
          <div className="pm-modal-header">
            <h4>Cronograma {timelineContrato ? `- ${timelineContrato.contrato}` : ''}</h4>
            <button className="pm-modal-close" onClick={() => this.fecharTimeline()}>
              <i className="fa fa-times"></i>
            </button>
          </div>

          {timelineContrato && (
            <div className="pm-timeline-info">
              <span><strong>Contrato:</strong> {timelineContrato.contrato}</span>
              <span><strong>Atendente:</strong> {timelineContrato.RegistradoPor || '-'}</span>
              <span><strong>Entrega:</strong> {timelineContrato.dt_entrega ? moment(timelineContrato.dt_entrega).format('DD/MM/YYYY') : '-'}</span>
              <span><strong>Formatura:</strong> {timelineContrato.dt_formatura ? moment(timelineContrato.dt_formatura).format('DD/MM/YYYY') : '-'}</span>
            </div>
          )}

          {timelineRefeito && timelineRefeito.totalVezes > 0 && (
            <div className="pm-refeito-card">
              <div className="pm-refeito-titulo">Refeito</div>
              <div className="pm-refeito-total">{timelineRefeito.totalVezes}</div>
              <div className="pm-refeito-label">Vez(es)</div>
              <div className="pm-refeito-detalhe">
                <span>Refeito {timelineRefeito.refeitoAlpha || 0} vez(es) por parte da Alpha</span>
                <span>Refeito {timelineRefeito.refeitoCliente || 0} vez(es) por parte do Cliente</span>
                <span>Contrato registrado por {timelineContrato ? timelineContrato.RegistradoPor : '-'}, alterado {timelineRefeito.totalVezes} vez(es) desde o início.</span>
              </div>
            </div>
          )}

          <div className="pm-timeline-body">
            {timelineLoading ? (
              <div className="text-center" style={{ padding: 40 }}>
                <i className="fa fa-refresh fa-spin" style={{ fontSize: 24 }}></i>
                <p style={{ marginTop: 10 }}>Carregando...</p>
              </div>
            ) : (
              <div className="pm-timeline">
                {timelineProcedimentos.map((proc, i) => (
                  <div key={i} className={`pm-timeline-step ${this.getStepClass(proc)}`} onClick={() => this.abrirComentario(proc)}>
                    <div className="pm-timeline-step-name">
                      {proc.nIndex}. {proc.procedimento}
                      {proc.atrasado ? <span className="pm-badge pm-badge-atrasado">Atrasado</span> : null}
                      {!proc.atrasado && (proc.Status || '').toLowerCase() === 'concluido' ? <span className="pm-badge pm-badge-concluido">Concluído</span> : null}
                      {!proc.atrasado && ((proc.Status || '').toLowerCase() === 'execução' || (proc.Status || '').toLowerCase() === 'execucao') ? <span className="pm-badge pm-badge-execucao">Execução</span> : null}
                      {!proc.atrasado && (proc.Status || '').toLowerCase() !== 'concluido' && (proc.Status || '').toLowerCase() !== 'execução' && (proc.Status || '').toLowerCase() !== 'execucao' ? <span className="pm-badge pm-badge-aguardando">Aguardando</span> : null}
                    </div>
                    <div className="pm-timeline-step-info">
                      {proc.dtini && <span>Início: {moment(proc.dtini).format('DD/MM/YYYY')}</span>}
                      {proc.dtfim && <span> | Prazo: {moment(proc.dtfim).format('DD/MM/YYYY')}</span>}
                      {proc.Resp && <span> | Resp: {proc.Resp}</span>}
                    </div>
                    <div className="pm-timeline-step-action">
                      <i className="fa fa-comment-o"></i> Comentar
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderComentario () {
    const { comentarioAberto, comentarioLoading, comentarioProc, comentarios, novoComentario, salvandoComentario, timelineContrato } = this.state;
    if (!comentarioAberto) return null;

    return (
      <div className="pm-comentario-overlay" onClick={() => this.fecharComentario()}>
        <div className="pm-comentario-modal" onClick={(e) => e.stopPropagation()}>
          <div className="pm-modal-header">
            <h4>Procedimento</h4>
            <button className="pm-modal-close" onClick={() => this.fecharComentario()}>
              <i className="fa fa-times"></i>
            </button>
          </div>
          <div className="pm-comentario-body">
            <div className="pm-comentario-info">
              <strong>{comentarioProc ? comentarioProc.procedimento : ''}</strong>
              <p>Contrato: {timelineContrato ? timelineContrato.contrato : ''}</p>
              <p>Início: {comentarioProc && comentarioProc.dtini ? moment(comentarioProc.dtini).format('DD/MM/YYYY') : '-'}</p>
              <p>Prazo: {comentarioProc && comentarioProc.dtfim ? moment(comentarioProc.dtfim).format('DD/MM/YYYY') : '-'}</p>
            </div>
            <div className="pm-comentario-form">
              <label>Comentar:</label>
              <textarea
                className="form-control"
                rows="3"
                value={novoComentario}
                onChange={(e) => this.setState({ novoComentario: e.target.value })}
                placeholder="Digite seu comentário..."
              />
              <div style={{ textAlign: 'right', marginTop: 8 }}>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => this.salvarComentario()}
                  disabled={salvandoComentario || !novoComentario.trim()}
                >
                  {salvandoComentario ? <i className="fa fa-refresh fa-spin"></i> : 'Postar'}
                </button>
              </div>
            </div>
            <div className="pm-comentario-historico">
              <strong>Histórico</strong>
              {comentarioLoading ? (
                <div className="text-center" style={{ padding: 20 }}>
                  <i className="fa fa-refresh fa-spin"></i>
                </div>
              ) : comentarios.length > 0 ? (
                <div className="pm-comentario-lista">
                  {comentarios.map((c, i) => (
                    <div key={i} className="pm-comentario-item">
                      <div className="pm-comentario-item-header">
                        <strong>{c.usuario || 'Usuário'}</strong>
                        <span>{c.data ? moment(c.data).format('DD/MM/YYYY HH:mm') : ''}</span>
                      </div>
                      <p>{c.comentario}</p>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-muted" style={{ marginTop: 10 }}>Nenhum comentário registrado.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderCronograma () {
    const { cronogramaLoading, cronogramaData, cronogramaSemanaInicio } = this.state;
    const hoje = moment().format('YYYY-MM-DD');

    // Gerar 7 dias da semana
    const dias = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(cronogramaSemanaInicio);
      d.setDate(d.getDate() + i);
      dias.push(moment(d));
    }

    const diasSemana = ['SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB', 'DOM'];
    const labelInicio = dias[0].format('DD/MM');
    const labelFim = dias[6].format('DD/MM');

    // Categorias
    const categorias = [
      { key: 'PUB', label: 'PUB', classe: 'cronograma-cat-pub', procs: ['Publicação do Convite', 'Publicação da Capa Dura'] },
      { key: 'REP', label: 'REP', classe: 'cronograma-cat-rep', procs: ['Republicação do Convite', 'Republicação da Capa Dura'] },
      { key: 'BUREAU', label: 'BUREAU', classe: 'cronograma-cat-bureau', procs: ['Liberação Bureau do Convite/Perso', 'Liberação de Bureau Capa Dura'] }
    ];

    // Organizar dados por categoria e dia
    const primeiroDia = dias[0].format('YYYY-MM-DD');
    const organizarPorDia = (procsFilter) => {
      const porDia = {};
      dias.forEach(d => { porDia[d.format('YYYY-MM-DD')] = []; });
      cronogramaData.forEach(item => {
        if (!procsFilter.includes(item.procedimento)) return;
        const diaItem = moment(item.dtfim).format('YYYY-MM-DD');
        if (porDia[diaItem] !== undefined) {
          porDia[diaItem].push(item);
        } else if (diaItem < primeiroDia) {
          // Atrasado de semanas anteriores: mostra no primeiro dia
          porDia[primeiroDia].push(item);
        }
      });
      return porDia;
    };

    return (
      <div className="cronograma-container">
        <div className="cronograma-header">
          <button className="cronograma-nav-btn" onClick={() => this.navegarSemana(-1)}>
            <i className="fa fa-chevron-left"></i>
          </button>
          <span className="cronograma-semana-label">{labelInicio} - {labelFim}</span>
          <button className="cronograma-nav-btn" onClick={() => this.navegarSemana(1)}>
            <i className="fa fa-chevron-right"></i>
          </button>
        </div>

        {cronogramaLoading ? (
          <div className="text-center" style={{ padding: 30 }}>
            <i className="fa fa-refresh fa-spin" style={{ fontSize: 24 }}></i>
            <p style={{ marginTop: 10 }}>Carregando...</p>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="cronograma-grid">
              <thead>
                <tr>
                  <th style={{ width: 70 }}></th>
                  {dias.map((d, i) => (
                    <th key={i} className={d.format('YYYY-MM-DD') === hoje ? 'cronograma-hoje' : ''}>
                      {diasSemana[i]}<br/>{d.format('DD/MM/YYYY')}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {categorias.map(cat => {
                  const porDia = organizarPorDia(cat.procs);
                  return (
                    <tr key={cat.key}>
                      <td className={`cronograma-category-label ${cat.classe}`}>{cat.label}</td>
                      {dias.map((d, i) => {
                        const diaKey = d.format('YYYY-MM-DD');
                        const items = porDia[diaKey] || [];
                        const isHoje = diaKey === hoje;
                        const maxShow = 5;
                        return (
                          <td key={i} className={`cronograma-cell ${isHoje ? 'cronograma-hoje' : ''}`}>
                            {items.slice(0, maxShow).map((item, j) => {
                              const atrasado = moment(item.dtfim).isBefore(moment(), 'day');
                              return (
                                <span
                                  key={j}
                                  className={`cronograma-item ${atrasado ? 'cronograma-item-atrasado' : 'cronograma-item-normal'}`}
                                  title={`${item.contrato} - ${item.procedimento} - ${item.RegistradoPor}`}
                                  onClick={() => this.abrirTimeline(item.codContrato)}
                                >
                                  {item.contrato} -&gt; {item.procedimento.replace('Publicação d', 'Pub. ').replace('Republicação d', 'Rep. ').replace('Liberação Bureau do ', 'Bureau ').replace('Liberação de Bureau ', 'Bureau ')}
                                </span>
                              );
                            })}
                            {items.length > maxShow && (
                              <span className="cronograma-ver-mais">+{items.length - maxShow} mais</span>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }

  render () {
    const { loading, ano, designer, procedimentos } = this.state;

    return (
      <div>
        <div className="box box-default">
          <div className="box-header with-border">
            <h3 className="box-title">Procedimentos</h3>
            <div className="box-tools pull-right">
              <div className="proc-mensal-filtros">
                <select
                  className="form-control input-sm"
                  value={ano}
                  onChange={(e) => this.setState({ ano: parseInt(e.target.value, 10) }, () => this.carregarDados())}
                >
                  {[2024, 2025, 2026, 2027].map(a => (
                    <option key={a} value={a}>{a}</option>
                  ))}
                </select>
                <select
                  className="form-control input-sm"
                  value={designer}
                  onChange={(e) => this.setState({ designer: e.target.value }, () => { this.carregarDados(); this.carregarCronograma(); })}
                >
                  <option value="">TODOS</option>
                  {DESIGNERS.map((d, i) => (
                    <option key={i} value={d}>{d}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="box-body">
            {loading ? (
              <div className="text-center" style={{ padding: 40 }}>
                <i className="fa fa-refresh fa-spin" style={{ fontSize: 30 }}></i>
                <p style={{ marginTop: 10 }}>Carregando...</p>
              </div>
            ) : procedimentos.length === 0 ? (
              <p className="text-center text-muted" style={{ padding: 40 }}>Nenhum dado encontrado para o período selecionado.</p>
            ) : (
              procedimentos.map(proc => this.renderTabelaProcedimento(proc))
            )}

            {this.renderCronograma()}
          </div>
        </div>

        {this.renderDetalhe()}
        {this.renderTimeline()}
        {this.renderComentario()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
  }
}

export default connect(mapStateToProps, {})(DashboardProcedimentos);



// WEBPACK FOOTER //
// ./src/views/DashboardProcedimentos/index.js